<template>
  <div class="assets">
    <heading type="h1">Assets</heading>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'

export default {
  name: 'Assets',
  components: {
    Heading
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/pages/assets.vue